import type { Options } from '@splidejs/splide';

/** Parity with former Slick quote slider (dots on, no arrows, single slide). */
export const quoteSliderSplideOptions: Options = {
	type: 'slide',
	rewind: true,
	perPage: 1,
	perMove: 1,
	pagination: true,
	arrows: false,
	speed: 500,
};
